import { useEffect } from 'react';
import { isNative, getPlatform } from '../utils/platform';

/**
 * Wires the Android hardware back button.
 * @param {Function} onBack - called when back is pressed. Return true to say "handled" (don't exit).
 */
export function useAndroidBackButton(onBack) {
  useEffect(() => {
    if (!isNative() || getPlatform() !== 'android') return;
    let listener;
    let cancelled = false;

    (async () => {
      const { App } = await import('@capacitor/app');
      if (cancelled) return;
      listener = await App.addListener('backButton', async () => {
        const handled = onBack && onBack();
        if (!handled) {
          try { await App.exitApp(); } catch {}
        }
      });
    })();

    return () => {
      cancelled = true;
      if (listener) listener.remove();
    };
  }, [onBack]);
}
